import React from 'react'
import Styled from 'styled-components'
import { transparentize } from 'polished'

import Viewport from 'components/Viewport'
import ComponentPreviewRenderer from 'components/ComponentPreviewRenderer'
import Icon from 'components/Icon'

const Container = Styled.div`
  position: relative;
  height: 0;
  padding-bottom: calc(100% / (8 / 7));
`

const Card = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.theme.colors.gray.shade50};
  border-radius: ${props => props.theme.radius};

  &:hover {
    background-color: ${props => props.theme.colors.gray.shade100};
  }
`

const Canvas = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 3rem 1rem 4rem 1rem;
  overflow: hidden;
`

const ViewportContainer = Styled.div`
  max-width: 100%;
  box-shadow: 0 0.25rem 1rem 0 rgba(51, 51, 51, 0.1);
`

const Label = Styled.div`
  position: absolute;
  left: 0;
  bottom: 1rem;
  width: 100%;
  font-family: ${props => props.theme.fonts.regular};
  font-size: 0.8rem;
  font-weight: bold;
  color: ${props => props.theme.colors.gray.shade600};
  text-align: center;
`

const Overlay = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  background-color: ${props => transparentize(0.5, props.theme.colors.gray.shade500)};
  border-radius: ${props => props.theme.radius};
  cursor: pointer;
  transition: 300ms;

  &:hover {
    opacity: 1;
  }
`

const IconExtended = Styled(Icon)`
  font-size: 3rem;
  color: ${props => props.theme.colors.white};
`

export default props => (
  <Container onClick={props.onClick}>
    <Card>
      <Canvas>
        <ViewportContainer>
          <Viewport device="desktop">
            <ComponentPreviewRenderer
              theme={props.theme}
              pageComponent={{
                _id: props.component._id,
                component: props.component,
                attrs: {}
              }}
            />
          </Viewport>
        </ViewportContainer>
      </Canvas>

      <Label>{props.component.name}</Label>
    </Card>

    <Overlay>
      <IconExtended liga="add_circle" />
    </Overlay>
  </Container>
)


// WEBPACK FOOTER //
// ./src/components/BrowserItem/index.js